import { ActionCreator, createAction, Action } from '@ngrx/store';

export const createHTTPActions = <
  RequestPayload = void,
  ResponsePayload = void,
  ErrorPayLoad = void,
>(
  actionType: string,
): [
  ActionCreator<
    string,
    (props?: RequestPayload) => {
      payload: RequestPayload;
    } & Action<string>
  >,
  ActionCreator<
    string,
    (props?: ResponsePayload) => {
      payload: ResponsePayload | undefined;
    } & Action<string>
  >,
  ActionCreator<
    string,
    (props?: ErrorPayLoad) => {
      payload: ErrorPayLoad | undefined;
    } & Action<string>
  >,
] => [
  createAction(actionType, (payload?: RequestPayload): { payload: RequestPayload } => ({
    payload,
  })),
  createAction(
    `${actionType} Success`,
    (
      payload?: ResponsePayload,
    ): {
      payload: ResponsePayload | undefined;
    } => ({ payload }),
  ),
  createAction(
    `${actionType} Error`,
    (
      payload?: ErrorPayLoad,
    ): {
      payload: ErrorPayLoad | undefined;
    } => ({ payload }),
  ),
];
